"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsProvider = void 0;
const SERVICE_NOT_INITIALIZED_ERROR = 'FeatureFlagsService is not initialized';
class FeatureFlagsProvider {
    static get featureFlags() {
        if (!window.featureFlagsService) {
            throw new Error(SERVICE_NOT_INITIALIZED_ERROR);
        }
        return window.featureFlagsService;
    }
}
exports.FeatureFlagsProvider = FeatureFlagsProvider;
